import _ from 'underscore';
import { createOrUpdateCampaign } from '@bingads-webui-campaign-react/perf-max-data';
import { Campaign } from '@bingads-webui/campaign-odata-schemas';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/wizard-shared-components';
import {
  viewModelToBulkModelForLocationTargets,
  viewModelToBulkModelForAdSchedules,
  getBulkUploadErrorType, modelToViewModelForBulkErrors, removeReferencedEntityInvalidIdErrors, unexpectedBulkErrorToString,
  isBulkWrappedResponse,
  genericApiError,
} from '@bingads-webui-campaign-react/perf-max-step-wizard';
import { viewModelToBulkModelForCampaign, bulkModelToViewModelForCampaign } from './campaign';

const bulkUpsertCampaignSettingsEntityErrorMap = {
  [getBulkUploadErrorType(Campaign)]: ERROR_ENTITY.Campaign,
  'Campaign Location Criterion Error': ERROR_ENTITY.CampaignLocation,
  'Campaign Radius Criterion Error': ERROR_ENTITY.CampaignRadius,
  'Campaign Negative Location Criterion Error': ERROR_ENTITY.CampaignNegativeLocation,
  'Campaign Location Intent Criterion Error': ERROR_ENTITY.CampaignLocationIntent,
  'Campaign Day Time Criterion Error': ERROR_ENTITY.CampaignDayTimeCriterion,
};

export const getErrorsPlaceholders = () => ({
  serverErrors: [],
  systemErrors: [],
});

export const saveCampaign = ({
  campaign: campaignViewModel,
  bundleCountries,
  bundleLocationCriterions,
}, { scenario, i18n, activityLogger }) => {
  const campaignModel = viewModelToBulkModelForCampaign(campaignViewModel);
  const locationTargetsModel = viewModelToBulkModelForLocationTargets(campaignViewModel, bundleLocationCriterions);
  const adSchedulesModel = viewModelToBulkModelForAdSchedules(campaignViewModel);

  const modelToSave = {
    ...campaignModel,
    CampaignCriterions: [
      ...locationTargetsModel,
      ...adSchedulesModel,
    ],
  };

  return createOrUpdateCampaign(modelToSave)
    // with bulk the result will have shape of:
    // - { ...entityData } - in case of success;
    // - { entity: { ...entityData }, errors: [(EditorialError|MTError)] } - in case of error(s).
    .then((result) => {
      const campaign = bulkModelToViewModelForCampaign({
        campaignModel: result,
        originalCampaignViewModel: campaignViewModel,
        bundleCountries,
      });

      const data = {
        campaign,
        ...getErrorsPlaceholders(),
      };

      return data;
    }, (bulkOrSystemError) => {
      if (isBulkWrappedResponse(bulkOrSystemError)) {
        const { entity, errors } = bulkOrSystemError;
        const campaign = entity ?
          bulkModelToViewModelForCampaign({
            campaignModel: entity,
            bundleCountries,
          }) :
          campaignViewModel;

        let filteredErrors = errors;
        if (campaign.data.Id <= 0) {
          filteredErrors = removeReferencedEntityInvalidIdErrors(filteredErrors);
        }
        const serverErrors = modelToViewModelForBulkErrors(
          filteredErrors,
          bulkUpsertCampaignSettingsEntityErrorMap,
          scenario,
          i18n,
          activityLogger
        );

        const data = {
          campaign,
          ...getErrorsPlaceholders(),
          serverErrors,
        };

        return _.isEmpty(filteredErrors) ? data : Promise.reject(data);
      }

      // Activity
      // eslint-disable-next-line no-console
      console.warn(`Campaign bulk upsert system error: ${unexpectedBulkErrorToString(bulkOrSystemError)}`);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        campaign: campaignViewModel,
        ...getErrorsPlaceholders(),
        serverErrors: [genericApiError],
        // TODO: We would want to return the criterions with Ids, but UI's bulk drops them
      });
    });
};
